(function(){
    angular
        .module('appback')
        .directive('ngMicrobiologia04Atb', microbiologia04Atb);

        microbiologia04Atb.$inject = ['ResultadosService','$timeout'];
        function microbiologia04Atb(ResultadosService,$timeout){
            return {
	            //require: 'ngModel',
	            templateUrl: '/backend/resultadopeticion/template?name=microbiologia04atb.twig',
		          scope: {
                  //ngModel : '=',
                  item: '=',
                  animal: '='
              	},
            	link: function (scope, element, $attrs) {
		            return $timeout(function () {

		            	
		            	if(!scope.item.resultado){
		            		scope.item.resultado = { extra : { resultado : { antibiogramas : [{}] }}};
			            }else{
			            	if(!scope.item.resultado.extra){
	                    		scope.item.resultado = { extra : { resultado : {antibiogramas : [{}] } } };
			            	}else{
			            		if(!scope.item.resultado.extra.resultado.antibiogramas){
			            			scope.item.resultado.extra.resultado.antibiogramas = [{}];
			            		}
			            	}
			            }


	            		scope.antibioticos = [];
			            ResultadosService.getATB(scope.item.analitica_id,function(data){
	            			if(data.antibioticos.length>0){
	            				scope.antibioticos = data.antibioticos;
	            			}
			            });

			            scope.buscarInterpretacion = function(anti_id,micro_id,anti){
			            	ResultadosService.getIntAntibioticoMicro(anti_id,micro_id,scope.item.resultado.extra.resultado.antibiograma.tecnica_id,anti.antibiotico[anti_id].resultado,function(data){
		            			anti.antibiotico[anti_id].interpretacion = data.interpretacion;
				            });
			            }

			            scope.contarResultados = function(anti){
			            	var contador = 0;
			            	angular.forEach(anti.antibiotico, function (value, key) { 
				               	if(value.resultado!=""){
				               		contador++;
				               	}
				            });   
				            return contador;
			            	//console.log(anti);
			            	//return Object.keys(anti.antibiotico).length;
			            }

			            scope.optionsMicroorganismos = { 
		            		ajax: {
		                        url: "/backend/resultadopeticion/select2microorganismo",
		                        dataType: 'json',
		                        delay: 250,
		                        data: function (params) {
		                          return {
		                            q: params.term, // search term
		                            page: params.page,
		                            field: 'nombre',
		                            per_page: 20,
		                            nodetype:'microorganismo'
		                          };
		                        },
		                        processResults: function (data, params) {
		                          params.page = params.page || 1;
		                          return {
		                            results: data.items,
		                            pagination: {
		                              more: (params.page * 1) < data.total_count
		                            }
		                          };
		                        },
		                        cache: true
		                    },
		                    templateSelection: format,
		                    templateResult: format
	                	};

		            	function format(icon) {
	                        var originalOption = icon.element;
	                          var str = "";
	                          if(typeof $(originalOption).data('icon') != 'undefined'){
	                            str+='<i class="icon alt'+$(originalOption).data('icon')+'"></i> <span>'+icon.text+'</span>';
	                            return $(str+" ");
	                          }else{
	                            return icon.text || icon.value;
	                          }
	                    }

	                    scope.borrar = function(index){
	                    	scope.item.resultado.extra.resultado.antibiogramas.splice(index,1);
	                    }

	                    scope.nuevo = function(){
	                    	scope.item.resultado.extra.resultado.antibiogramas.push({});
	                    }

			        });
		        }
          }
      }
})();